import { render, staticRenderFns } from "./PermissionSelector.vue?vue&type=template&id=134fccad&scoped=true&"
import script from "./PermissionSelector.vue?vue&type=script&lang=js&"
export * from "./PermissionSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134fccad",
  null
  
)

export default component.exports